async function addStickerToCartItem(currentCartItem) {
  if (currentCartItem.properties["_svg-url"]) {
    const openSVG = document.getElementById(`open-svg-link-${currentCartItem.key}`);
    const svgUrl = currentCartItem.properties["_svg-url"];

    const response = await fetch(svgUrl);
    const svgText = await response.text();

    const svgFragment = document.createRange().createContextualFragment(svgText.replace('<?xml version="1.0" encoding="utf-8"?>', ""));
    const svgElement = svgFragment.querySelector("svg");

    if (svgElement) {
      openSVG.replaceChildren(svgElement);
      openSVG.href = svgUrl;
    }
  }
}

async function addStickerToOrderItem(lineItem) {
  const openSVG = document.getElementById(`open-svg-link-${lineItem.id}`);
  if (openSVG) {
    const svgUrl = lineItem.properties.find(
      (propertyTuple) => propertyTuple[0] === "_svg-url"
    )?.[1];

    if (svgUrl) {
      const response = await fetch(svgUrl);
      const svgText = await response.text();

      const svgFragment = document.createRange().createContextualFragment(svgText.replace('<?xml version="1.0" encoding="utf-8"?>', ""));
      const svgElement = svgFragment.querySelector("svg");

      if (svgElement) {
        openSVG.replaceChildren(svgElement);
        openSVG.href = svgUrl;
      }
    }
  }
}

